import { Link } from "react-router-dom";
import { ArrowLeft, IceCream2 } from "lucide-react";
import MenuSection from "../components/MenuSection";
import { useLang } from "../context/LanguageContext";
import { sectionT } from "../i18n/translations";
import { gourmandiseMenu } from "../data/menuData";

export default function CarteGourmandise() {
  const { t, lang } = useLang();

  return (
    <div data-testid="gourmandise-page" className="pt-28 pb-10 px-4 sm:px-6">
      <div className="mx-auto max-w-7xl">
        <Link
          to="/"
          data-testid="back-home-link"
          className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-amber-200 mb-8 transition"
        >
          <ArrowLeft className="w-4 h-4" />
          {t.back_home}
        </Link>

        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex glass-pill px-4 py-2 items-center gap-2 mb-6">
            <IceCream2 className="w-4 h-4 text-amber-300" />
            <span className="text-xs uppercase tracking-[0.3em] text-amber-200/90">
              ✦ L'Oasis ✦
            </span>
          </div>
          <h1
            data-testid="page-title"
            className="font-serif text-5xl sm:text-6xl lg:text-7xl text-white leading-[0.95] mb-5"
          >
            {t.card_gourmandise_title}
          </h1>
          <p className="text-white/70 max-w-2xl mx-auto text-base sm:text-lg leading-relaxed">
            {t.menu_intro_gourmandise}
          </p>
        </div>

        <div className="glass-card p-4 mb-12 overflow-x-auto" data-testid="menu-nav">
          <div className="flex gap-2 min-w-max">
            {gourmandiseMenu.map((s) => (
              <a
                key={s.id}
                href={`#${s.id}`}
                className="px-4 py-2 text-xs uppercase tracking-wider rounded-full text-white/75 hover:text-amber-200 hover:bg-white/5 whitespace-nowrap transition"
              >
                {sectionT[s.sectionKey]?.[lang] || s.sectionKey}
              </a>
            ))}
          </div>
        </div>

        <div className="space-y-20 md:space-y-28">
          {gourmandiseMenu.map((section, i) => (
            <MenuSection key={section.id} section={section} index={i} />
          ))}
        </div>
      </div>
    </div>
  );
}
